<template>
    <main :class="bodyClass">
        <slot></slot>
    </main>
</template>

<script>
    export default {
        props: {
            hasLargePadding: { type: Boolean, default: false },
        },

        computed: {
            bodyClass() {
                return {
                    'page-plain': true,
                    'page-plain--has-large-padding': this.hasLargePadding,
                }
            },
        },
    }
</script>
